import { createSceneReducer } from '../../reducers-util';
import tasksDataReducer from './tasks.data';
import tasksUiReducer from './tasks.ui';

export default createSceneReducer(tasksDataReducer, tasksUiReducer);
